<template>
	<div
		class="
			mr-6 mb-5 flex h-[127px] w-[517px] flex-col items-center justify-start
			rounded-b-lg shadow-file-handler-popover
		"
	>
		<div class="flex h-[53px] w-full items-center  justify-between rounded-t-lg bg-won-dark-blue px-[15px]">
			<span class="font-[Inter] text-base font-semibold text-white">{{ titleText }}</span>
			<svg
				class="cursor-pointer"
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				@click="cancelUpload"
			><g clip-path="url(#clip0_555_30145)"><path
				d="M15.8333 5.34166L14.6583 4.16666L10 8.825L5.34166 4.16666L4.16666 5.34166L8.825 10L4.16666 14.6583L5.34166 15.8333L10 11.175L14.6583 15.8333L15.8333 14.6583L11.175 10L15.8333 5.34166Z"
				fill="white"
			/></g><defs><clipPath id="clip0_555_30145"><rect
				width="20"
				height="20"
				fill="white"
			/></clipPath></defs></svg>
		</div>
		<div class="flex h-[74px] w-full items-center justify-between rounded-b-lg bg-[#FFFFFF] px-[15px]">
			<span class="flex items-center justify-start">
				<svg
					width="20"
					height="20"
					viewBox="0 0 20 20"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				><g clip-path="url(#clip0_555_30146)"><path
					d="M16.6667 1.66667H6.66669C5.75002 1.66667 5.00002 2.41667 5.00002 3.33333V13.3333C5.00002 14.25 5.75002 15 6.66669 15H16.6667C17.5834 15 18.3334 14.25 18.3334 13.3333V3.33333C18.3334 2.41667 17.5834 1.66667 16.6667 1.66667ZM9.58335 7.91667C9.58335 8.60834 9.02502 9.16667 8.33335 9.16667H7.50002V10.8333H6.25002V5.83333H8.33335C9.02502 5.83333 9.58335 6.39167 9.58335 7.08333V7.91667ZM13.75 9.58333C13.75 10.275 13.1917 10.8333 12.5 10.8333H10.4167V5.83333H12.5C13.1917 5.83333 13.75 6.39167 13.75 7.08333V9.58333ZM17.0834 7.08333H15.8334V7.91667H17.0834V9.16667H15.8334V10.8333H14.5834V5.83333H17.0834V7.08333ZM7.50002 7.91667H8.33335V7.08333H7.50002V7.91667ZM3.33335 5H1.66669V16.6667C1.66669 17.5833 2.41669 18.3333 3.33335 18.3333H15V16.6667H3.33335V5ZM11.6667 9.58333H12.5V7.08333H11.6667V9.58333Z"
					fill="#2A8176"
				/></g><defs><clipPath id="clip0_555_30146"><rect
					width="20"
					height="20"
					fill="white"
				/></clipPath></defs></svg>

				<span class="ml-2 font-[Inter] text-base font-normal text-black">
					{{ truncateString(filename, 20) }}
				</span>
			</span>
			<div class="flex items-center justify-between">
				<div
					v-if="!error"
					class="h-[4px] w-[253px] rounded-full bg-won-sand-light"
				>
					<div
						:style="{'width': `${progress}%`}"
						:class="['h-full rounded-full bg-won-green transition-all duration-10 ease-out']"
					/>
				</div>
				<div
					v-else-if="error"
					class="w-[253px] text-right"
				>
					<span class="font-[Inter] text-sm font-normal text-[#FF4F4F]">{{ error }}</span>
				</div>
				<svg
					v-if="uploading && !error"
					class="ml-4 cursor-pointer"
					width="20"
					height="20"
					viewBox="0 0 20 20"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					@click="cancelUpload"
				><g clip-path="url(#clip0_555_30150)"><path
					d="M10 1.66667C5.39166 1.66667 1.66666 5.39167 1.66666 10C1.66666 14.6083 5.39166 18.3333 10 18.3333C14.6083 18.3333 18.3333 14.6083 18.3333 10C18.3333 5.39167 14.6083 1.66667 10 1.66667ZM14.1667 12.9917L12.9917 14.1667L10 11.175L7.00833 14.1667L5.83333 12.9917L8.825 10L5.83333 7.00833L7.00833 5.83333L10 8.825L12.9917 5.83333L14.1667 7.00833L11.175 10L14.1667 12.9917Z"
					fill="#686E77"
				/></g><defs><clipPath id="clip0_555_30150"><rect
					width="20"
					height="20"
					fill="white"
				/></clipPath></defs></svg>
				<svg
					v-if="error"
					class="ml-4 cursor-pointer"
					width="20"
					height="20"
					viewBox="0 0 20 20"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				><g clip-path="url(#clip0_555_30427)"><path
					d="M10.0001 1.66666C5.40008 1.66666 1.66675 5.4 1.66675 10C1.66675 14.6 5.40008 18.3333 10.0001 18.3333C14.6001 18.3333 18.3334 14.6 18.3334 10C18.3334 5.4 14.6001 1.66666 10.0001 1.66666ZM10.8334 14.1667H9.16675V12.5H10.8334V14.1667ZM10.8334 10.8333H9.16675V5.83333H10.8334V10.8333Z"
					fill="#FF4F4F"
				/></g><defs><clipPath id="clip0_555_30427"><rect
					width="20"
					height="20"
					fill="white"
				/></clipPath></defs></svg>
				<svg
					v-if="!uploading && !error"
					class="ml-4 cursor-pointer"
					width="20"
					height="20"
					viewBox="0 0 20 20"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				><g clip-path="url(#clip0_555_30342)"><path
					d="M9.99996 1.66667C5.39996 1.66667 1.66663 5.4 1.66663 10C1.66663 14.6 5.39996 18.3333 9.99996 18.3333C14.6 18.3333 18.3333 14.6 18.3333 10C18.3333 5.4 14.6 1.66667 9.99996 1.66667ZM8.33329 14.1667L4.16663 10L5.34163 8.825L8.33329 11.8083L14.6583 5.48333L15.8333 6.66667L8.33329 14.1667Z"
					fill="#2A8176"
				/></g><defs><clipPath id="clip0_555_30342"><rect
					width="20"
					height="20"
					fill="white"
				/></clipPath></defs></svg>
			</div>
		</div>
	</div>
</template>

<script setup>
import { computed, toRefs } from 'vue';
import { truncateString } from '../utils/helpers.js';
 
const props = defineProps({
	progress: {
		type: Number,
		required: true
	}, 
	filename: {
		type: String,
		default: null
	}, 
	uploading: {
		type: Boolean,
		default: false
	},
	error: {
		type: String,
		default: null
	},
	action: {
		type: String,
		default: 'upload',
		validator: (value) => ['upload', 'download'].includes(value),
	}
});

const emit = defineEmits(['cancel']);

const cancelUpload = () => {
	emit('cancel');
};

const { action, uploading, error } = toRefs(props);

// eslint-disable-next-line vue/return-in-computed-property
const titleText = computed(() => {
	if (action.value === 'upload') {
		if (error.value) {
			return 'Upload failed';
		} 
		else if (uploading.value) {
			return 'Uploading item';
		}
		
		return 'Uploaded item';
		
	} else if (action.value === 'download') {
		if (error.value) {
			return 'Download failed';
		} 
		else if (uploading.value) {
			return 'Downloading item';
		}
		
		return 'Downloaded item';
		
	}
});
</script>
